import { oc } from '@orpc/contract';
import { correctVehicleInputSchema, vehicleDetailSchema } from '../schemas/vehicles.schemas.js';
/**
 * An administrator's correction of a recorded figure (plan §5.6; PP §4).
 *
 * It is the only way a sold vehicle is ever touched again, and it never edits history in place: the
 * decision is stored as a `CORRECTION` approval, the old and new values as an activity row, and a money
 * field writes a fresh `CORRECTION` snapshot so every derived figure moves with it.
 */
export const correctVehicleContract = oc
    .route({
    method: 'POST',
    path: '/vehicles/{vehicleId}/corrections',
    tags: ['Vehicles'],
    summary: 'Correct one recorded figure, with a reason',
})
    .input(correctVehicleInputSchema)
    .output(vehicleDetailSchema);
//# sourceMappingURL=correct-vehicle.contract.js.map